const WeightUnitsSelect = ({ onClick, activeWeightUnit }) => {
  return(
    <div className='weightUnitsSelect'>
      Select your weight units:<br/>
      <div className='weightUnitsSelectButtonGroup'>
        <div className={`weightUnitsSelectButton roundLeft ${activeWeightUnit === 'lbs' ? 'buttonActive' : ''}`} 
          onClick={() => onClick('lbs')}>lbs</div>
        <div className={`weightUnitsSelectButton roundRight ${activeWeightUnit === 'kgs' ? 'buttonActive' : ''}`} 
          onClick={() => onClick('kgs')}>kg</div>
      </div>
    </div>
  )
}

export default WeightUnitsSelect